import React from 'react';
import { LeftPanelContainer } from './TabLeftPanel.style';
/* Komponent lewego panelu  dla zakładki */
export var TabLeftPanel = function (props) { return (React.createElement(LeftPanelContainer, null, props.children)); };
